import { Injectable, Pipe } from '@angular/core';
import {
  BehaviorSubject,
  Observable,
  filter,
  merge,
  switchMap,
  tap,
  of,
} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MainService {
  mainStreamsActions$ = new BehaviorSubject({});

  MainStreamWrraper<T>(
    func: ((action?: any) => Observable<T>) | Observable<T>,
    filterCondition: ((action: any) => boolean) | undefined = undefined,
    initAction:any| undefined = undefined,
    before: ((action?: any) => any) | undefined,
    mainStream: undefined | Observable<any> = undefined
  ): Observable<T> {
    if (undefined == mainStream) {
      mainStream = this.mainStreamsActions$;
    }
    const funcObs = func instanceof Observable ? () => func : func;

    const beforeObs = before instanceof Function ? before : () => before;

    if (initAction) {
      mainStream = merge(funcObs(initAction), mainStream);
    }
  
    if (filterCondition) {
      mainStream = mainStream.pipe(filter(filterCondition));
    }
  
    mainStream = mainStream.pipe(switchMap((action) => {
      return of(action).pipe(
        tap(beforeObs),
        switchMap(funcObs)
      );
    }));
  
    

    return mainStream;
  }
  // Utilisation:

  // constructor(private mainStream: MainStreamService) {}
  // sendAction(type = 'todos-action', category = 'fragrances') {
  //   this.mainStream.mainStreamsActions$.next({ type, category });
  // }
  // todos$ = this.mainStream.MainStreamWrraper(
  //   (action: any) =>
  //     this.http
  //       .get(`https://dummyjson.com/products/category/${action.category}`)
  //       .pipe(map((res: any) => res.products)),

  //   (action: any) => action.type == 'todos-action',

  //   { category: 'smartphones' }
  // );
  // categories$ = this.mainStream
  //   .MainStreamWrraper(
  //     this.http.get(`https://dummyjson.com/products/categories`)
  //   )
  //   .pipe(takeWhile((response: any) => response.length == 0, true));
  // test$ = this.mainStream.MainStreamWrraper(
  //   this.http.get(`https://dummyjson.com/products/categories`),

  //   undefined,

  //   {},

  //   this.mainStream.mainStreamsActions$.pipe(
  //     distinctUntilChanged(
  //       (p: any, c: any) => p.type == c.type && p.category == c.category
  //     )
  //   )
  // );
}
